import React from "react";
import "./about.css";
function About() {
  return (
    <div className="about">
      <div className="about-top">
        <div className="about-info">
          Hello There ✋, I am
         <br /> <a href="https://duythuc.vercel.app" className="info-name">Thuc Nguyen</a>.
         <br /> Senior Mobile & Frontend Developer with 10+ years building scalable, high-performance applications across fintech, e-commerce, and blockchain.
         <br />
         <a href="/nguyen_duy_thuc.pdf" download="Nguyen_Duy_Thuc_CV.pdf" className="download-cv" target="_blank">
           Download My CV
         </a>
        </div>
        <div className="about-photo">
          <img
            src={require("../../../assets/coding.png")}
            className="picture"
            alt="Coding illustration"
          />
        </div>
      </div>
      {/* <SocialContact /> */}
    </div>
  );
}

export default About;

